import type { ItemBreakdown as GQLItemBreakdown } from '../generated/checkout.graphql';
import { take } from '../util/takePayload';

export type ItemBreakdown = {
  basePrice: number;
  price: number;
  total: number;
  // Only the order summary query selects these; the cart query does not.
  convenienceFee?: number;
  discountAmount?: number;
};

export const fromGql = (gqlItem: GQLItemBreakdown): ItemBreakdown =>
  take(gqlItem, 'basePrice', 'total', 'price', 'convenienceFee', 'discountAmount') as ItemBreakdown;
